<template>
    <div class="wrap">
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
            </div>
            <div class="align-self-end">
                <input-debounced
                    v-model="search"
                    :clearable="true"
                    :autofocus="true"
                    placeholder="Search"
                    class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
            :base-url="urlWithFilters"
            ref="baseTable"
            @load-success="onLoadSuccess"
            @refresh="onRefresh"
            :current-page="currentPage"
            v-loading="isRefreshing"
            element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                    :data="items"
                    stripe
                    class="w-100"
                >
                    <el-table-column type="expand" v-slot="{row}">
                        <expand-column :row="row"></expand-column>
                    </el-table-column>
                    <el-table-column
                        prop="conversation.contact"
                        label="Contact"
                        min-width="150"
                        :formatter="formatContact"
                    ></el-table-column>
                    <el-table-column
                        prop="status_text"
                        label="Status"
                        min-width="70"
                    ></el-table-column>
                    <el-table-column
                        prop="sent_at"
                        label="Sent at"
                        min-width="150"
                        :formatter="formatDate"
                    ></el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
            layout="prev, pager, next"
            :total="total"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            class="text-right"
        ></el-pagination>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import {addQueryParams} from '../../libs/url';
  import ExpandColumn from './message-expand-column';

  export default {
    extends: TableWithPagination,

    components: {
      ExpandColumn,
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },

    watch: {
      search: function (value) {
        this.filters = value
          ? _.assign({}, this.filters, {search: value})
          : this.filters = _.omit(this.filters, ['search']);
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {object|null} value
       */
      formatDate(row, col, value) {
        const datetime = _.get(value, 'datetime', null);

        return _.isNull(datetime)
          ? '-'
          : moment(datetime).format(config('format.moment.full.datetime'));
      },

      /**
       * @param {object} row
       * @param {object} col
       * @param {object|null} contact
       */
      formatContact(row, col, {full_name = '', phone_number = ''}) {
        return `${full_name} (${phone_number})`;
      },
    }
  }
</script>
